import moment from 'moment';
import DATE_FORMATS from '../constants/dateFormats';
import { isEmpty } from './helper';
import { format as dateFnsFormat, isValid } from 'date-fns';

/**
 * Formats a date for API or UI.
 *
 * @param {Date|string|moment.Moment} date
 * @param {string} format
 * @returns {string|null}
 */
export const formatDate = (date, format = DATE_FORMATS.YYYY_MM_DDTHH_mm_ss) => {
  if (isEmpty(date)) {
    return null;
  }
  return moment(date).format(format);
};

export const formatDateValue = (date, format = DATE_FORMATS.yyyy_MM_dd, fallback = null) => {
  if (!date || !isValid(new Date(date))) {
    return fallback;
  }
  return dateFnsFormat(new Date(date), format);
};
